// TICKET-01342: reopening a closed journal is a clinic-admin action with a
// mandatory reason (journals are legal records). Single source for the
// unlock-icon visibility and the reopen-reason validation — mirrored by
// backend/lib/journal-audit.js, enforced by POST /api/journals/reopen/.
export function canReopenJournal({ isAdmin, isCustomerAdmin, journal } = {}) {
    if (!journal || !journal.closed) {
        return false;
    }
    return !!(isAdmin || isCustomerAdmin);
}

export function isValidReopenReason(reason) {
    return typeof reason === 'string' && reason.trim().length > 0;
}

// TICKET-01359: deleting a journal is always reason-gated (legal record).
// Open journals: any clinic user. Closed journals: clinic admins only —
// same rule as reopening. Deleted journals can be restored under the same
// gating. Mirrored by the backend delete-journal / post-journal-undelete
// routes.
export function canDeleteJournal({ isAdmin, isCustomerAdmin, journal } = {}) {
    if (!journal || journal.offline) {
        return false;
    }
    if (journal.closed) {
        return !!(isAdmin || isCustomerAdmin);
    }
    return true;
}

export function canUndeleteJournal({ isAdmin, isCustomerAdmin, journal } = {}) {
    if (!journal || !journal.offline) {
        return false;
    }
    if (journal.closed) {
        return !!(isAdmin || isCustomerAdmin);
    }
    return true;
}

export function isValidDeleteReason(reason) {
    return typeof reason === 'string' && reason.trim().length > 0;
}
